import { useDispatch, useSelector } from "react-redux";
import { closeGalleryOfService, closePanels, closeTopPanel, hideAcceptingForm, hideContact, hideFaq, hidePrivateService, hideSectionBanner, hideServiceList, hideTeamsMenu, setSection, showContentSection, showHeroBanner, toggleHeroService } from "../features/serviceSlice";
import "./Header.css";
import { toSlug } from "../utils/slug";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function Header({ onOpenAcceptingForm, onOpenExploreMenu, onBeforeServiceNavigate }) {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const [openMenu, setOpenMenu] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isMobileMenuBlurVisible, setIsMobileMenuBlurVisible] = useState(false);
    const [selectedMobileMenuId, setSelectedMobileMenuId] = useState(null);
    const [pendingServiceSlug, setPendingServiceSlug] = useState(null);
    const mobileMenuTimerRef = useRef(null);
    const {
        showInfo,
        activeSection,
        serviceList,
        expanded,
        switchServiceList,
        showTopHeroBanner,
        privateService,
        serviceData
    } = useSelector(state => state.service);

    const isPrivateServicesMenuVisible = !showTopHeroBanner && !privateService && !expanded && !switchServiceList && !serviceList;
    const shouldHideNav = !serviceList && !expanded && !switchServiceList && !showTopHeroBanner && !isPrivateServicesMenuVisible;
    const mobileMenuTransitionMs = 520;
    const currentServiceSlug = location.pathname.startsWith("/services")
        ? location.pathname.split("/").filter(Boolean)[1]
        : null;
    const activeServiceSlug = pendingServiceSlug || currentServiceSlug;

    useEffect(() => {
        return () => {
            if (mobileMenuTimerRef.current) {
                clearTimeout(mobileMenuTimerRef.current);
            }
        };
    }, []);

    useEffect(() => {
        setPendingServiceSlug(null);
    }, [location.pathname]);

    const clearMobileMenuTimer = () => {
        if (mobileMenuTimerRef.current) {
            clearTimeout(mobileMenuTimerRef.current);
            mobileMenuTimerRef.current = null;
        }
    };

    const closeMobileMenu = () => {
        clearMobileMenuTimer();
        setIsMobileMenuOpen(false);
        setSelectedMobileMenuId(null);
        mobileMenuTimerRef.current = setTimeout(() => {
            setOpenMenu(null);
            setIsMobileMenuBlurVisible(false);
            mobileMenuTimerRef.current = null;
        }, mobileMenuTransitionMs);
    };

    const navigateToServiceCategory = (section) => {
        if (onBeforeServiceNavigate) {
            onBeforeServiceNavigate();
        }

        dispatch(closeGalleryOfService());
        dispatch(showContentSection());
        dispatch(setSection(section.title));
        dispatch(closeTopPanel());
        dispatch(hideSectionBanner());
        dispatch(hideTeamsMenu());
        dispatch(closePanels());
        dispatch(hideFaq());
        dispatch(hideContact());
        dispatch(hidePrivateService());
        setPendingServiceSlug(toSlug(section.title));
        navigate(`/services/${toSlug(section.title)}`);
    };

    const openMobileServiceMenu = (section) => {
        clearMobileMenuTimer();

        if (openMenu?.id === section.id && isMobileMenuOpen) {
            closeMobileMenu();
            navigateToServiceCategory(section);
            return;
        }

        if (isMobileMenuOpen || isMobileMenuBlurVisible) {
            setIsMobileMenuOpen(false);
            setIsMobileMenuBlurVisible(true);
            mobileMenuTimerRef.current = setTimeout(() => {
                setOpenMenu(section);
                setSelectedMobileMenuId(section.id);
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => setIsMobileMenuOpen(true));
                });
                mobileMenuTimerRef.current = null;
            }, mobileMenuTransitionMs);
            return;
        }

        setSelectedMobileMenuId(section.id);
        setOpenMenu(section);
        setIsMobileMenuBlurVisible(true);
        requestAnimationFrame(() => setIsMobileMenuOpen(true));
    };

    const mobileMenuLayer = (
        <>
            <div
                className={`mobile-menu-page-blur ${isMobileMenuBlurVisible ? "open" : ""}`}
                onClick={closeMobileMenu}
            />
            <div className={`pullDownMobileMenu ${isMobileMenuOpen ? "open" : "closed"} ${isMobileMenuBlurVisible ? "has-shadow" : ""}`}>
                <ul>
                    {openMenu && openMenu.items.map((p, index) => {
                        return (
                            <li key={index}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(hideAcceptingForm());
                                    closeMobileMenu();
                                    dispatch(closeGalleryOfService());
                                    dispatch(showContentSection());
                                    setPendingServiceSlug(toSlug(openMenu.title));
                                    navigate(
                                        `/services/${toSlug(openMenu.title)}/${toSlug(p.label)}`
                                    );

                                }}>
                                {p.label}
                            </li>
                        )
                    })}
                </ul>
            </div>
        </>
    );

    return (
        <>
            <header className="blacklabel-header">
                <nav className={`nav-left ${shouldHideNav ? "d-none" : ""}`}>
                    {serviceData?.length ? (
                        serviceData.map((x) => (
                            <span
                                key={x.id}
                                className={
                                    selectedMobileMenuId === x.id ||
                                    (!selectedMobileMenuId && activeServiceSlug === toSlug(x.title))
                                        ? "nav-service-active"
                                        : ""
                                }
                                onClick={(e) => {
                                    e.stopPropagation();
                                    dispatch(hideAcceptingForm());

                                    // ✅ MOBILE LOGIC
                                    if (window.innerWidth < 768) {
                                        openMobileServiceMenu(x);
                                        return;
                                    } else {
                                        if (onBeforeServiceNavigate) {
                                            onBeforeServiceNavigate();
                                        }

                                        // DESKTOP (same as before)
                                        setPendingServiceSlug(toSlug(x.title));
                                        dispatch(closeGalleryOfService());
                                        dispatch(showContentSection());
                                        dispatch(setSection(x.title));
                                        dispatch(hideTeamsMenu());
                                        dispatch(closePanels());
                                        dispatch(hideFaq());
                                        dispatch(hideContact());
                                        dispatch(hidePrivateService());

                                        setTimeout(() => {
                                            dispatch(setSection(x.title));
                                        }, 400)

                                        if (activeSection !== x.title) {
                                            dispatch(hideSectionBanner());
                                            dispatch(hideServiceList());
                                            setTimeout(() => {
                                                navigate(`/services/${toSlug(x.title)}`);
                                            }, 900)
                                        } else {
                                            navigate(`/services/${toSlug(x.title)}`);
                                        }
                                    }


                                }}
                            >
                                {x.title.split(" ")[0]}
                                {/* {x.title.trim().split(" ")[0]} */}
                            </span>
                        ))
                    ) : (
                        <span style={{ opacity: 0 }}>PLACEHOLDER</span>
                    )}



                </nav>

                <div className="nav-right">
                    <p className="member1" onClick={(e) => {
                        e.stopPropagation();
                        if (onOpenAcceptingForm) onOpenAcceptingForm();
                    }}>RESERVE</p>
                    <p className="accepting-header-btn" onClick={(e) => {
                        e.stopPropagation();
                        if (onOpenAcceptingForm) onOpenAcceptingForm();
                    }}>
                        RESERVE
                    </p>

                    <div className="hamburger" onClick={(e) => {
                        e.stopPropagation();
                        if (window.innerWidth < 768 && isMobileMenuOpen) {
                            closeMobileMenu();
                        }
                        dispatch(showContentSection());
                        dispatch(hideAcceptingForm());

                        if (showInfo) {
                            dispatch(closeTopPanel())
                            dispatch(showHeroBanner())
                            dispatch(hideTeamsMenu())
                            navigate(`/services`)
                        } else {
                            if (onOpenExploreMenu) {
                                onOpenExploreMenu();
                            } else {
                                dispatch(toggleHeroService())
                                setTimeout(() => {
                                    navigate(`/services`)
                                }, 900)
                            }
                            dispatch(hideSectionBanner())
                            dispatch(hideTeamsMenu())
                            dispatch(hidePrivateService())

                        }
                    }}>
                        <span />
                        <span />
                        <span />
                    </div>
                </div>
            </header>

            {typeof document !== "undefined"
                ? createPortal(mobileMenuLayer, document.body)
                : mobileMenuLayer}

        </>

    );
}
